import store from '@/store/store'
export default (to, from, next) => {
  const userInfo = store.state.userInfo
  if (userInfo) {
    next()
  } else {
    next('/login')
  }
}
